import { schema } from '@mesa/core/zero';
import { Row } from '@rocicorp/zero';
import { CircleDashedIcon } from 'lucide-react';

import { CancelledIcon } from './cancelled-icon';
import { DoneIcon } from './done-icon';
import { InReviewIcon } from './in-review-icon';

export type PullState = Row<typeof schema.tables.PullsTable>['state'];

export const PullStateIcon = ({
  state,
  width = 16,
  height = 16,
  className,
}: {
  state: PullState;
  width?: number;
  height?: number;
  className?: string;
}) => {
  switch (state) {
    case 'DRAFT':
      return <CircleDashedIcon width={width} height={height} className={className} />;
    case 'OPEN':
      return <InReviewIcon width={width} height={height} className={className} />;
    case 'CLOSED':
      return <CancelledIcon width={width} height={height} className={className} />;
    case 'MERGED':
      return <DoneIcon width={width} height={height} className={className} />;
  }
};
